import { watch, type Ref } from 'vue'
import type { PaginaConfig } from './usePersonalizzazione'

const STYLE_ID = 'sezioni-nascoste-dynamic'

/**
 * Nasconde automaticamente elementi della pagina in base a `config.sezioniNascoste`,
 * iniettando un tag <style> globale in <head>.
 *
 * Ogni voce in sezioniNascoste può essere:
 *   - Un ID shorthand:      "timbrature"      → [data-sezione="timbrature"]
 *   - Un selettore CSS:     "[name=email]"    → qualunque selettore valido
 *                           "#panel-mensa"
 *                           ".campo-whatsapp"
 *
 * Le pagine possono (ma non devono) aggiungere data-sezione per le sezioni
 * principali; per i singoli campi si usano gli attributi già esistenti (name, id).
 *
 * Chiamato una sola volta da AppLayout, si aggiorna ad ogni cambio di route.
 */
export function useSezioniNascoste(config: Ref<PaginaConfig>) {
  function toSelector(entry: string): string {
    // Se inizia con un carattere da selettore CSS, usalo direttamente.
    // Altrimenti è un ID shorthand per [data-sezione="xxx"].
    return /^[.#\[]/.test(entry)
      ? entry
      : `[data-sezione="${CSS.escape(entry)}"]`
  }

  function applica(nascoste: string[]) {
    let styleEl = document.getElementById(STYLE_ID) as HTMLStyleElement | null
    if (!styleEl) {
      styleEl = document.createElement('style')
      styleEl.id = STYLE_ID
      document.head.appendChild(styleEl)
    }
    styleEl.textContent = nascoste
      .map((entry) => `${toSelector(entry)} { display: none !important; }`)
      .join('\n')
  }

  watch(() => config.value.sezioniNascoste, applica, { deep: true, immediate: true })
}
